import { combineReducers } from 'redux';

import { collaborationModuleReducer } from './collaborationModuleReducer';
import { tasksReducer } from './tasksReducer';

export const collaborationReducer = combineReducers({
    module: collaborationModuleReducer,
    tasks: tasksReducer,
});
